import { render, staticRenderFns } from "./Receivables.vue?vue&type=template&id=ada13034&"
import script from "./Receivables.vue?vue&type=script&lang=js&"
export * from "./Receivables.vue?vue&type=script&lang=js&"
import style0 from "./Receivables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports